import { tickerItems } from '@/mocks/home';

export default function TopTicker() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="border-b border-background-200 bg-foreground-950 text-background-50">
      <div className="mx-auto flex h-11 max-w-[1400px] items-center gap-4 px-4 md:px-6">
        <div className="flex shrink-0 items-center gap-2">
          <span className="flex h-6 w-6 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-sm" />
          </span>
          <span className="whitespace-nowrap text-xs font-semibold tracking-wide text-background-100">
            实时快讯
          </span>
        </div>

        <div className="ticker-mask relative min-w-0 flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10">
            {loop.map((item, index) => (
              <span key={`${item.text}-${index}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-background-200">
                <i className="ri-record-circle-line text-[10px] text-primary-400" />
                {item.text}
                <span className="text-accent-400">{item.heat}</span>
              </span>
            ))}
          </div>
        </div>

        <div className="hidden shrink-0 items-center gap-4 text-xs text-background-300 lg:flex">
          <span className="flex items-center gap-1">
            <i className="ri-time-line text-sm" />
            更新时间 09-12 18:20
          </span>
        </div>
      </div>
    </div>
  );
}